<template>
    <div>
        <b-overlay :show="tableLoading" rounded="sm">
            <b-card class="p-3">
                <b-col class="page-block"><strong>
                        {{ $translate("page") }}: {{ pagination.page }}
                        {{ $translate("of") }} {{ pageCount }} {{ $translate("total") }}:
                        {{ pagination.total }}
                    </strong></b-col>
                <b-card-header class="p-0">
                    <b-row>
                        <div class="pe-2">
                            <button id="bulk-transfer-btn" :disabled="!hasPermissionUpdate && !hasPermissionCreate
                                " class="btn blue-button" v-b-tooltip.hover :title="$translate('bulk_transfer')"
                                @click="bulkTransfer()">
                                <img src="@/assets/images/icon/bulk-transfer.svg" />
                            </button>
                        </div>
                        <b-col md="2" class="ps-0">
                            <div class="d-flex">
                                <button id="show-filter-btn" class="btn blue-button me-2"
                                    @click="shouldShowFilters = !shouldShowFilters">
                                    <span style="white-space: nowrap">
                                        {{ $translate('filters') }}
                                        <b-icon :icon="`chevron-${shouldShowFilters ? 'up' : 'down'
                                            }`"></b-icon>
                                    </span>
                                </button>
                                <button id="reset-filter-btn" class="btn blue-button" variant="light" size="sm"
                                    @click="resetFilters" v-b-tooltip.hover :title="$translate('reset_filters')">
                                    <b-icon icon="arrow-repeat" variant="dark"></b-icon>
                                </button>
                            </div>
                        </b-col>
                        <b-col class="d-flex justify-content-end">
                            <slot></slot>
                        </b-col>
                    </b-row>
                    <SectionItemsQueryFilter class="mt-12" :locations="locations" :items="sectionMasterItems"
                        :types="types" :officers="users" v-show="shouldShowFilters" ref="queryFilter" v-model="filters"
                        :disabled-officers="!hasPermissionView" :officer-option="officerOption" />
                </b-card-header>
                <b-card-body class="p-0 mt-3">
                    <b-table :items="sectionMasterItems" :fields="itemFields" hover :filter="filters" responsive
                        :per-page="itemsPerPage" :current-page="currentPage" selectable @row-selected="onRowSelected"
                        ref="selectable" id="warehouse_inventory_table">
                        <template>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <!-- <strong>{{ $translate('loading') }}</strong> -->
                            </div>
                        </template>
                        <template #head(check)>
                            <!-- {{itemsPerPage}}{{selectedsectionMasterItems}} -->
                            <b-form-checkbox class="test-check-row" v-if="sectionMasterItems.length > 0" :checked="itemsPerPage ===
                                selectedsectionMasterItems.length
                                " @change="toggleAllRow()"></b-form-checkbox>
                        </template>
                        <template #cell(check)="{ rowSelected, index }">
                            <b-form-checkbox class="test-check-row-selected" :checked="rowSelected"
                                @change="toggleRow(index, rowSelected)"></b-form-checkbox>
                        </template>
                        <template #cell(Warehouse)="{ item }">
                            <div v-html="getInventoryLocation(item)"></div>
                        </template>
                        <template #cell(actions)="{ item }">
                            <b-button :disabled="!hasPermissionUpdate && !hasPermissionCreate
                                " class="mr-2 text-black test-transfer-view" @click="singleTransfer(item)"
                                variant="pink-button">
                                <img src="@/assets/images/icon/transfer.svg" />
                            </b-button>
                        </template>
                        <template #empty>
                            <div>
                                No Data Available
                            </div>
                        </template>
                    </b-table>
                    <b-row>
                        <b-col>
                            <b-pagination class="justify-content-center mt-4" v-model="pagination.page"
                                :total-rows="pagination.total" :per-page="pagination.pageSize"
                                aria-controls="customerTable" :prev-text="$translate('previous')"
                                :next-text="$translate('next')" pills></b-pagination>
                        </b-col>
                    </b-row>
                </b-card-body>
            </b-card>
        </b-overlay>
    </div>
</template>

<script>
import _ from 'lodash'
import permissionsMixins from '@/mixins/permissionsMixins'
import SectionItemsQueryFilter from './SectionItemsQueryFilter.vue'

import popupMixins from '@/mixins/popupMixins'
import showItemHelper from '@/mixins/showItemHelper'
import importMixins from '@/mixins/importMixins'

export default {
    name: 'inventoryTransfer-ListItems',
    components: { SectionItemsQueryFilter },
    props: ['type', 'title', 'item'],
    mixins: [popupMixins, showItemHelper, importMixins, permissionsMixins],

    data() {
        return {
            tableLoading: false,
            disabled: false,
            filters: {
                location_id: null,
                order_item_type_id: null,
                officer_id: null,
                product_search: null,
                section_search: null,
                quantity: null,
                quantity_type: 1,
            },
            itemsPerPage: 15,
            currentPage: 1,
            selectedsectionMasterItems: [],
            islocationSection: false,
            isOfficerSection: false,
            istypeSection: false,
            isProduct: false,
            isSectionSection: false,
            section_id: null,
            user_id: null,
            location_id: null,
            shouldShowFilters: false,
            bulkAction: 'none',
            type_id: null,
            reportType: 'section_items',
        }
    },
    async mounted() {
        ///this.resetFilters()
        await this.doSearch()
    },
    computed: {
        itemFields() {
            return [
                "check",
                {
                    key: 'actions',
                    label: this.$translate('actions'),
                },
                {
                    key: 'name',
                    label: this.$translate('name'),
                },
                {
                    key: 'ext_reference_code',
                    label: this.$translate('code'),
                },
                {
                    key: 'order_item_type_id',
                    label: this.$translate('type'),
                    formatter: (value, key, item) =>
                        item.type && item.type.name,
                },

                {
                    key: 'Warehouse',
                    label: this.$translate('inventory_location'),
                },

                {
                    key: 'vendor_id',
                    label: this.$translate('vendor'),
                    formatter: (value, key, item) =>
                        item.vendor && item.vendor.name,
                },

                {
                    key: 'uom',
                    label: this.$translate('uom'),
                    formatter: (value, key, item) => item.uom,
                },
                {
                    key: 'selling_price',
                    label: this.$translate('price'),
                    formatter: (value, key, item) => item.selling_price,
                },
                {
                    key: 'quantity',
                    label: this.$translate('qty_on_hand'),
                    formatter: (value, key, item) =>
                        item.section && item.section.quantity_on_hand,
                },
            ]
        },
        officerOption() {
            return '----officers----'
        },
        locations() {
            return this.$store.state.locations.locations.filter(
                x => x.is_warehouse || x.sections.some(y => !y.is_officer)
            )
        },
        defaultLocationId() {
            if (this.locations.length) {
                return this.locations[0].id
            }
            return null
        },
        defaultProductSearch() {
            return 'a'
        },
        sections() {
            const { location_id } = this
            return (
                (
                    this.$store.state.locations.locations.find(
                        x => x.id == location_id
                    ) || {}
                ).sections || []
            ).filter(x => !x.is_officer)
        },
        sectionMasterItems() {
            const _items = this.$store.state.masterItem.section_items
            console.log("items-----:", _items)
            const data = []
            for (const key in _items) {
                const item = _items[key];
                if (!item.vendor) {
                    item.vendor = {};
                }
                data.push(item);
            }
            return data
        },
        users() {
            return this.$store.getters['users/sorted_officers']
        },
        types() {
            return this.$store.state.itemType.items.filter(
                x => !x.is_discount && !x.is_task
            )
        },
        rows() {
            return this.sectionMasterItems.length
        },

        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize);
        },
        pagination() {
            return this.$store.state.masterItem.sectionPagination || { page: 1 };
        },
    },
    watch: {
        'filters.order_item_type_id': function () {
            this.doSearch()
        },

        'filters.product_search': _.debounce(function () {
            this.doSearch()
        }, 500),

        'filters.section_search': _.debounce(function () {
            this.doSearch()
        }, 500),

        'filters.quantity': function () {
            this.doSearch()
        },

        'filters.quantity_type': function () {
            this.doSearch()
        },

        'filters.officer_id': function () {
            this.doSearch()
        },

        'filters.location_id': function () {
            this.doSearch()
        },

        report_loading: function (val) {
            this.$emit('report-state', val)
        },
        user_id: function (id) {
            const user = this.users.find(x => x.id == id)
            if (user) this.section_id = user.location_section_id
            else this.section_id = null
        },

        section_id: function (id) {
            if (id) this.$store.dispatch('masterItem/fetchBySection', id)
            else this.$store.commit('masterItem/SET_SECTION_ITEMS', [])
        },
        isOfficerSection: function () {
            this.section_id = null
            this.location_id = null
            this.user_id = null
        },
        "pagination.page": function () {
            this.clearSelected();
            this.doSearch();
        },
    },
    created() { },

    methods: {
        resetFilters() {
            this.filters = {
                location_id: null,
                order_item_type_id: null,
                officer_id: null,
                product_search: null,
                section_search: null,
                quantity: null,
                quantity_type: 1,
            }
            this.doSearch()
        },
        getInventoryLocation(item) {
            console.log("getInventoryLocation:", item)
            if (!item.section) {
                return ''
            }

            if (item?.section?.officers?.length) {
                return (
                    `<strong>${this.$translate('officer')}</strong>: ` +
                    (item.section.officers[0] &&
                        item.section.officers[0].first_name +
                        ' ' +
                        item.section.officers[0].last_name)
                )
            } else {
                return (
                    (item?.section?.location?.name ?? "") +
                    `:` +
                    (item?.section?.name ?? "")
                )
            }
        },

        async doSearch() {
            let {
                filters,
                pagination: { page },
            } = this
            page = parseInt(page) || 1;
            try {
                this.tableLoading = true
                await this.$store.dispatch('masterItem/fetchSection', {
                    page,
                    filters,
                })
            } catch (err) {
                console.log('fetchSection doSearch err', err)
            } finally {
                this.tableLoading = false
            }
        },
        getSectionQuantity(sections, section_id) {
            sections = sections || []
            if (section_id) {
                const section = sections.find(
                    x => x.location_section_id === section_id
                )
                if (!section) return 0
                return section.quantity_on_hand
            } else {
                return sections.reduce((_sum, section) => {
                    _sum += section.quantity_on_hand
                }, 0)
            }
        },
        info(item, index, button) {
            this.infoModal.title = `Row index: ${index}`
            this.infoModal.content = JSON.stringify(item, null, 2)
            this.$root.$emit('bv::show::modal', this.infoModal.id, button)
        },
        resetInfoModal() {
            this.infoModal.title = ''
            this.infoModal.content = ''
        },
        onRowSelected(items) {
            this.selectedsectionMasterItems = items
        },
        selectAllRows() {
            this.$refs.selectable && this.$refs.selectable.selectAllRows()
        },
        clearSelected() {
            this.$refs.selectable && this.$refs.selectable.clearSelected()
        },
        clearAllSelect() {
            this.selectedsectionMasterItems = []
        },
        toggleRow(index, rowSelected) {
            if (rowSelected) this.$refs.selectable.unselectRow(index)
            else this.$refs.selectable.selectRow(index)
        },
        toggleAllRow() {
            if (this.itemsPerPage === this.selectedsectionMasterItems.length)
                this.$refs.selectable && this.$refs.selectable.clearSelected()
            else this.$refs.selectable.selectAllRows()
        },
        singleTransfer(item) {
            this.$store.commit('masterItem/SET_TRANSFER_ITEMS', [item])
        },
        bulkTransfer() {
            if (this.selectedsectionMasterItems.length > 0) {
                this.$store.commit(
                    'masterItem/SET_TRANSFER_ITEMS',
                    this.selectedsectionMasterItems
                )
            } else {
                this.doToast(
                    this.$translate('error'),
                    this.$translate(`select_for_bulk_transfer`),
                    'danger',
                )
            }
        },
    },
}
</script>
<style>
#warehouse_inventory_table td {
    white-space: normal !important;
    max-width: 254px;
}
</style>